export const dateInDjangoFormat = (date) => {
    if (date == null) {
        return null;
    }
    if (typeof date === 'string') {
        if (date.includes('T')) {
            return date.split('T')[0];
        }
        return date;
    }
    // Want to convert date in the YYYY-MM-DD format for Django storage
    return (
        date.getFullYear().toString() +
        "-" +
        ("0" + (date.getMonth() + 1).toString()).slice(-2) +
        "-" +
        ("0" + date.getDate().toString()).slice(-2)
    );
};

export const getPreviousDate = (startDate) => {
    let date;
    if (typeof startDate === 'object') {
        date = new Date(startDate.getTime());
    } else {
        if (startDate.includes(':')) {
            date = new Date(startDate);
        } else {
            date = new Date(startDate + 'T00:00:00');
        }
    }
    date.setDate(date.getDate() - 1);
    return dateInDjangoFormat(date);
};

export const getPreviousYear = (startDate) => {
    let date;
    if (typeof startDate === 'object') {
        date = new Date(startDate.getTime());
    } else {
        if (startDate.includes(':')) {
            date = new Date(startDate);
        } else {
            date = new Date(startDate + 'T00:00:00');
        }
    }
    date.setFullYear(date.getFullYear() - 1);
    return dateInDjangoFormat(date);
};

export const getDayMonthFromDate = (date) => {
    if (!date) {
        return null;
    }
    return date.split('-').slice(1).join('-');
}

export const addDaysToDate = (numberOfDays, date) => {
    if (!date) {
        date = new Date();
    }
    // https://stackoverflow.com/questions/3818193/how-to-add-number-of-days-to-todays-date
    date = date.setDate(date.getDate() + numberOfDays); // https://stackoverflow.com/questions/11343939/how-to-add-weeks-to-date-using-javascript
    return new Date(date);
}


// WEBPACK FOOTER //
// ./src/utils/datetime-handling.js